// extracted by mini-css-extract-plugin
var _1 = "CalendarGridWeekNowLine-moduleCalendarGridWeekNowLine__TSQsn";
export { _1 as "CalendarGridWeekNowLine" }
